import Inventories from "./Inventories";

export default Inventories;
